import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

export const useOnDVRDurationChanged = (
    onDVRDurationChanged: (duration: number | undefined) => void
) => {
    useInstanceEffect(
        (instance) =>
            instance.onCurrentTimeChange(() => onDVRDurationChanged(instance.dvrDuration)),
        [onDVRDurationChanged]
    );
};
